export const pushDataToGTM = ( { transactionId, transactionAmount } ) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push( { 
    event: 'stripeCheckoutSuccess', 
    transactionId, 
    transactionAmount,
  } );
};